module.exports = __webpack_public_path__ + "static/img/4.c5625ef.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/2/zh/4.png
// module id = 6rRl
// module chunks = 0